import Vue from 'vue'
import App from './App.vue'
import router from './router' // 路由设置
import { setRem } from './plugin/rem/rem'
import fetch from './plugin/axios/fetch'

// 移动端调试vConsole
// 需要启动移动端调试，在url上加上vConsole=true即可
// import vConsole from './utils/vconsole'
// vConsole()

// 选择是否使用vuex状态管理
import store from './store/index'

import VueClipboard from 'vue-clipboard2'

// 页面动画依赖vuex, 如果需要页面过渡，请务必使用vuex状态管理
// 关闭页面过渡动画, 默认开启
// store.dispatch('appShell/disablePageTransition')

Object.defineProperty(Vue.prototype, '$fetch', { value: fetch })

// 复制
Vue.use(VueClipboard)

// rem
setRem(document, window)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
